import { render, staticRenderFns } from "./saleinfo.vue?vue&type=template&id=50d09822&scoped=true&"
import script from "./saleinfo.vue?vue&type=script&lang=js&"
export * from "./saleinfo.vue?vue&type=script&lang=js&"
import style0 from "./saleinfo.vue?vue&type=style&index=0&id=50d09822&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d09822",
  null
  
)

export default component.exports